/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'analytics';
const componentName = 'timing-tiles';
const prefix = `${moduleName}.${componentName}`;

export const licenseUpgradeMessage = `${prefix}.licenseUpgradeMessage`;

export const ENGLISH = {
    [licenseUpgradeMessage]: 'Upgrade your license to use End-to-End timing.',
};
